import clsx from 'clsx';

import { BaseButton, BaseButtonProps } from './BaseButton';

export function OutlinedButton(props: BaseButtonProps) {
  const { className, children, ...rest } = props;

  const baseClassList = [
    'bg-secondary-button',
    'border-[1px]',
    'border-secondary-button-text',
    'border-solid',
    'rounded-full',
    'font-size-[15px]',
    'font-weight-[600]',
    'px-[16px]',
    'text-secondary-button-text',
    'hover:brightness-95',
    'disabled:text-[#a6a6a6]',
    'disabled:border-[#a6a6a6]'
  ];

  return (
    <BaseButton className={clsx(baseClassList, className)} {...rest}>
      {children}
    </BaseButton>
  );
}
